import { Typography } from "@mui/material";
import { useState } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import style from "./styles";

const Faq = ({ faqs, header = "FAQ's" }) => {
  const [expanded, setExpanded] = useState(false);
  const handlePanel = (panel) => {
    let panelDt = expanded === panel ? 0 : panel;
    setExpanded(panelDt);
  };

  return (
    <>
      <Typography component="p" sx={style.header}>
        {header}
      </Typography>
      {faqs?.data &&
        faqs?.data?.map((faq) => {
          return (
            <div
              className={
                expanded === faq?.id + 1 ? "accordion show" : "accordion"
              }
              key={faq?.id}
              id={faq?.id}
            >
              <div
                className="accordion-label"
                onClick={() => handlePanel(faq?.id + 1)}
              >
                {faq?.attributes?.question}
              </div>
              <div className="accordion-content">
                <ReactMarkdown remarkPlugins={[remarkGfm]}>
                  {faq?.attributes?.answer}
                </ReactMarkdown>
              </div>
            </div>
          );
        })}
    </>
  );
};

export default Faq;
